import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import ReelCreator from "./pages/ReelCreator";
import ReelDetail from "./pages/ReelDetail";
import CarouselDetail from "./pages/CarouselDetail";
import Brands from "./pages/Brands";
import BrandForm from "./pages/BrandForm";
import Pricing from "./pages/Pricing";
import PaymentSuccess from "./pages/PaymentSuccess";
import Workspace from "./pages/Workspace";
import Referrals from "./pages/Referrals";
import PublicSharedReel from "./pages/PublicSharedReel";
import Admin from "./pages/Admin";
import Privacy from "./pages/legal/Privacy";
import CookiePolicy from "./pages/legal/CookiePolicy";
import Terms from "./pages/legal/Terms";
import Contact from "./pages/Contact";
import CookieBanner from "./components/CookieBanner";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#09090B] text-zinc-500">
        <div className="flex items-center gap-3">
          <span className="w-2 h-2 rounded-full bg-[#FF4400] pulse-dot" />
          <span className="font-mono text-xs tracking-widest uppercase">Loading...</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const AdminOnly = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="min-h-screen bg-[#09090B]" />;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!user.is_admin) return <Navigate to="/dashboard" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              style: {
                background: "#18181B",
                border: "1px solid #27272A",
                color: "#fff",
                fontFamily: "Manrope, sans-serif",
              },
            }}
          />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/create" element={<Protected><ReelCreator /></Protected>} />
            <Route path="/reel/:id" element={<Protected><ReelDetail /></Protected>} />
            <Route path="/carousel/:id" element={<Protected><CarouselDetail /></Protected>} />
            <Route path="/brands" element={<Protected><Brands /></Protected>} />
            <Route path="/brands/new" element={<Protected><BrandForm /></Protected>} />
            <Route path="/brands/:id" element={<Protected><BrandForm /></Protected>} />
            <Route path="/workspace" element={<Protected><Workspace /></Protected>} />
            <Route path="/referrals" element={<Protected><Referrals /></Protected>} />
            <Route path="/admin" element={<AdminOnly><Admin /></AdminOnly>} />
            <Route path="/w/:slug/:reelId" element={<PublicSharedReel />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
